import { useState, useRef } from "react";
import { MODAL_TYPE } from "../../constants";
import Modal from "../modal/Modal";
import styles from "./FitGuideModal.scss";
import useEventBus from "../../hooks/useEventBus";
import useEventListener from "../../hooks/useEventListener";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { fireFitGuideFitTypeChangeAnalytics } from "../../analytics/pageInteraction";
import { handleTrackedEvent } from "../../utils/postMessageTrackedEvents";

type FitGuideEventData = {
  url: string;
  focusOnClose: HTMLElement | null;
};

export default function FitGuideModal() {
  const modalId = `${MODAL_TYPE.SIDE}${Math.floor(Math.random() * 10000)}`;

  const [open, setOpen] = useState<boolean>(false);
  const [contentLoaded, setContentLoaded] = useState<boolean>(false);
  const [fitGuideUrl, setFitGuideUrl] = useState<string | null>(null);
  const [focusOnCloseElement, setFocusOnCloseElement] =
    useState<HTMLElement | null>(null);
  type RuntimeConstants = {
    getTranslation: (key: string) => string;
  };
  const { getTranslation } = useRuntimeConstants() as RuntimeConstants;

  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const handleIframeMessage = (event: MessageEvent) => {
    const { data } = event;

    handleTrackedEvent(event, {
      fit_guide_fit_type_change: fireFitGuideFitTypeChangeAnalytics,
    });

    if (data === "fitGuide-closeButton") {
      closeModal();
    }
    if (data === "fitGuide-ready") {
      setContentLoaded(true);
    }
  };

  const closeModal = () => setOpen(false);

  const focusCloseButton = () => {
    iframeRef?.current?.contentWindow?.postMessage(
      "fit-guide-focus-close",
      "*"
    );
  };

  useEventBus(
    "fitGuideOpen",
    ({ url, focusOnClose }: FitGuideEventData) => {
      setOpen(true);
      setFitGuideUrl(url);
      setFocusOnCloseElement(focusOnClose);

      if (iframeRef?.current) {
        focusCloseButton();
      }
    },
    []
  );
  useEventListener("message", handleIframeMessage, []);

  return (
    <Modal
      modalType={MODAL_TYPE.SIDE}
      modalId={modalId}
      open={open}
      closeModal={closeModal}
      focusOnClose={focusOnCloseElement}
      hideCloseButton
      contentLoaded={contentLoaded}
      withScrollBar={false}
      useFocusTrapCatchAll={true}
    >
      <iframe
        data-testid="fit-guide-iframe"
        title={getTranslation("fit_guide_iframe_title")}
        src={fitGuideUrl ?? undefined}
        ref={iframeRef}
        className={styles.iframe}
        onLoad={() => {
          focusCloseButton();
        }}
      />
    </Modal>
  );
}
